import { gql } from '@apollo/client';

const operationResultFragment = gql`
  fragment OperationResultFields on OperationResult {
    Success
    Errors {
      Code
      Message
    }
  }
`;

export default operationResultFragment;
